import { ChangeDetectorRef, Component, inject, OnInit, ViewChild } from '@angular/core';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/ui-dialog-brain';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { EmblaCarouselDirective } from 'embla-carousel-angular';
import { WorkflowService } from '../../workflows/workflow.service';
import { CommonModule } from '@angular/common';
import { HotToastService } from '@ngneat/hot-toast';
import { SpinnerComponent } from '../spinner/spinner.component';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';

@Component({
  selector: 'app-import-workflow',
  standalone: true,
  imports: [CommonModule, SpinnerComponent, TranslateModule],
  providers: [],
  templateUrl: './import-workflow.component.html',
  styleUrl: './import-workflow.component.scss'
})
export class ImportWorkflowComponent implements OnInit {
  @ViewChild(EmblaCarouselDirective) protected emblaCarousel?: EmblaCarouselDirective;

  private readonly _dialogRef = inject<BrnDialogRef<any>>(BrnDialogRef);
  private readonly _dialogContext = injectBrnDialogContext<{ data: any}>();
  protected readonly data = this._dialogContext.data;

  file: any;
  showLoader: boolean = false;

  constructor(
    private dataCollectorService: DataCollectorService,
    private workflowService: WorkflowService,
    private changeDetectorRef: ChangeDetectorRef,
    private toast: HotToastService,
    private router: Router,
    private localisationService: LocalisationService
    
  ){}

  fileDrop(): void {
    this.changeDetectorRef.detectChanges();
  }

  public onDrop(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer?.files) {
      const droppedFiles = event.dataTransfer.files;
      if(droppedFiles?.length > 0){
        this.file = droppedFiles[0]
      }
    }
  }

  public onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  public onFileSelect(event: any): void {
    const selectedFiles: FileList = event.target.files;
    this.file = selectedFiles[0]
  }


  closeModal(): void {
    this._dialogRef.close();
  }

  exportWorkflow(): void {
    if(this.file){
      this.showLoader = true;
      const blob = new Blob([this.file], {type: this.file.type});
      const formData = new FormData();
      formData.append('file', blob, this.file?.name)
      this.dataCollectorService.uploadfile(this.workflowService.apiUrls.workflows+'/import', formData).subscribe({
        next: (res: any) => {
          this.showLoader = false;
          if(res?.data?.workflow_uid){
            window['urlState'] = 'workflow-builder'
            this.router.navigateByUrl('/workflow-builder/workflows/'+res?.data?.workflow_uid, {
              state: {
                checkVariable: true
              }
            })
          }
          this.toast.success('Workflow imported successfully');
          this._dialogRef.close(true);
        },
        error: (err: any) => {
          this.showLoader = false;
        }
      })
    }
  }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
  }
}
